import React from 'react'
import Assets from 'app/configs/assetConfigs'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Card, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { Routes } from 'app/services/routeService/routeService'
import SwitchLanguageBottom from 'app/components/SwitchLanguageBottom'
import { useFlag } from '@unleash/proxy-client-react'

const useStyles = makeStyles((theme) => ({
  logoImage: {
    width: 400,
  },
  footerText: {
    color: '#fff !important',
  },
}))

const ContainerNotifyMeCard = (props) => {
  const { footerMessage = '' } = props
  const classes = useStyles()

  return (
    <div className="flex flex-col my-auto">
      <div className="flex flex-col sm:pt-48 sm:pb-36 w-full">
        <div className="flex flex-row flex-wrap w-full mt-8 justify-center items-center">
          <Link
            to={Routes.root()}
            className={clsx(classes.logoImage, 'justify-center p-16')}
          >
            <img src={Assets.bannerRev} alt="logo" />
          </Link>
        </div>
      </div>
      <Card elevation={2} className="flex flex-col sm:w-10/12 w-11/12 mx-auto">
        {props.children}
        <SwitchLanguageBottom />
      </Card>
      <div className="flex flex-col items-center sm:w-10/12 w-11/12 mx-auto py-16">
        <Typography variant="body1" className="text-center text-white">
          {footerMessage}
        </Typography>
      </div>
    </div>
  )
}
export default ContainerNotifyMeCard
